/* ------------------------------------------ GRYFF COLLECTION SELECTOR - CHRIS 17.08.2016 ----------------------------------------- */
import HELPER from '@/app/utils/HELPER';
import api from '@/app/endpoints.js';
import { GET } from '@/app/api';
import { checkKeyValid } from '@/app/utils/checkRoleApply.ts';
import { base } from '@/app/editor/sidebar/constant';
import { app } from '@/store';

(function (jQuery) {
  jQuery.gfCollectionSelector = function (element, options) {
    const defaults = {
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const $cSelector = jQuery(
      '<a id="gf-pick-collection" class="button" href="#"><i class="fa fa-crosshairs" aria-hidden="true"></i> Pick a Collections</a>',
    );
    const $reloadCollection = jQuery(
      '<a id="gf-reload-collection" class="gf-reload-collection" href="#"><span class="icon icon-refresh"></span></a>',
    );
    const toolTipMessage = 'Refresh Collection Status';
    const _mdCollectionSelector = '<div id="md-collection-selector"></div>';
    const _content =
      '<div class="gfCS_search"> <svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M6.57,9.66c-1.68,0-3.05-1.37-3.05-3.06s1.37-3.06,3.05-3.06S9.62,4.9,9.62,6.59S8.26,9.66,6.57,9.66z M14,12.92l-3.68-3.7c0.52-0.75,0.83-1.65,0.83-2.63C11.15,4.06,9.1,2,6.57,2S2,4.06,2,6.59s2.05,4.59,4.57,4.59c1,0,1.92-0.33,2.68-0.88L12.92,14L14,12.92z" /></svg> <input type="text" id="search-collection" name="search-collection" value="" placeholder="Search collections" /> </div> <div class="gfCS_body"> <div class="collection-list"> <p class="text-center"></p> </div> <div class="search_notfound"> <span class="gfCS_icon_notfound"></span> <span class="text">No Collection Found</span> </div> </div>';

    const $elIconRefresh = '<span class="icon icon-refresh"></span>';
    const $elIconLoading = '<span class="snack-loading"><span class="icon icon-loading"></span>';

    let _collectionsData;
    let _cId;
    const $activeModal = jQuery(_mdCollectionSelector);
    let $collectionsList;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $divContentBk = $gfFrame.contents().find('#divContentBk');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $element.gfInputField();

      if ($element.next('.gfInputField').next('#gf-pick-collection').length == 0) {
        $element.next('.gfInputField').after($cSelector);
        $element.next('.gfInputField').after($reloadCollection);
        $element.next('.gfInputField').after("<div class='gf-collection-status'></div>");
      }
      this.applyEvents();

      const $cId = $element.parents('.columns').siblings().find('#cId');
      $cId.on('value-change', function () {
        $cId.trigger('input-change');
      });
      _cId = $cId && $cId.length ? $cId.val() : '';
      this.setCollectionStatus();
      $reloadCollection.gfTooltipsNew({
        postion: 'top',
        desc: toolTipMessage,
        timeIn: 0,
        timeOut: 0,
      });
    };

    this.hideGfTooltipNew = function () {
      const $el = document.getElementById('gfTooltipsNew').getElementsByClassName('gfTooltipsItem');
      if ($el && $el.length) {
        $el[0].style.display = 'none';
      }
    };

    this.setCollectionStatus = function () {
      const collection = HELPER.searchCollectionInList(_cId);
      if (!collection || (collection && _cId == 'auto')) {
        return;
      }
      const publishedAt = collection.published_at;
      _this.applyStatusSidebarSettings(publishedAt);
      _this.addClassInputByStatus(publishedAt);
    };

    this.reloadCollection = async function () {
      const $gfSGSettings = $element.closest('.gfSGSettings');
      const $gfReloadCollection = $gfSGSettings.find('.gf-reload-collection');
      if (!_cId || _cId == 'auto') {
        return;
      }
      _this.hideGfTooltipNew();
      const data = {
        ids: _cId,
      };
      $gfReloadCollection.addClass('disabled');
      $gfReloadCollection.html($elIconLoading);
      const res = await GET(api.getCollectionsByIds().url, data);
      const collections = (res.data && res.data.collections) || [];
      const collection = collections.find((item) => item.id == _cId);
      $gfReloadCollection.removeClass('disabled');
      $gfReloadCollection.html($elIconRefresh);
      if (!collection) {
        return;
      }
      const publishedAt = collection.published_at;
      _this.applyStatusSidebarSettings(publishedAt);
      _this.addClassInputByStatus(publishedAt);
      // update window._collectionArray
      HELPER.updateCollectionInList(collection);
    };

    this.applyStatusSidebarSettings = function (publishedAt) {
      const $gfCollectionStatus = $element.closest('.gfSGSettings').find('.gf-collection-status');
      if (publishedAt || !_cId || _cId == 'auto') {
        $gfCollectionStatus.html('');
        $gfCollectionStatus.removeClass('active');
        return;
      }
      $gfCollectionStatus.addClass('active');
      $gfCollectionStatus.html('Unavailable');
    };

    this.addClassInputByStatus = function (publishedAt) {
      const $gfInputFieldBox = $element.closest('.gfSGSettings').find('.gfInputField .gfInputFieldBox input');
      if (publishedAt || !_cId || _cId == 'auto') {
        $gfInputFieldBox.removeClass('has-status-collection');
        return;
      }
      $gfInputFieldBox.addClass('has-status-collection');
    };

    this.applyEvents = function () {
      $cSelector.off().on('click', function () {
        _this.showCollectionSelector();
      });

      $reloadCollection.off().on('click', function () {
        _this.reloadCollection();
      });

      $element.off('mousedown').on('mousedown', function () {
        $cSelector.trigger('click');
        return false;
      });
      return false;
    };

    this.showCollectionSelector = function () {
      const crEditID = $gfLeftSideBar.find('#md-settings').data('edittingID');
      if (crEditID.indexOf('-child') !== -1) {
        HELPER.showNotify("Can't change collection", 'error');
        return false;
      }

      $activeModal.appendTo($divContentHidden);
      $activeModal.gfModalNew({
        title: 'Select a collection',
        header: 'collectionSelector',
        footer: '',
        background: '#F3F5F9',
        width: 580,
        height: 613,
        left: $gfLeftSideBar.children().innerWidth(),
        top: $divTopBar.innerHeight(),
        loading: true,
        onContent: function ($content) {
          $content.html(_content);
        },
      });

      $activeModal.data('gfmodalnew').onShow();

      // Click btn Cancel
      $activeModal
        .find('.gfCS_footer .btnCancel')
        .off('click')
        .on('click', function () {
          $activeModal.remove();
        });

      // Click btn Reload
      const $actionReload = $activeModal.find('.gf_modal-header .gf_modal-right .gf_modal-reload');
      $actionReload.off('click').on('click', function () {
        $activeModal.find('#search-collection').val('');
        $activeModal.find('.search_notfound').removeClass('active');
        _this.getCollections();
      });

      $actionReload.gfTooltipsNew({
        postion: 'bottom',
        desc: toolTipMessage,
        timeIn: 0,
        timeOut: 0,
      });

      // Add notice
      _this.renderNotice();

      // update stuffs
      $collectionsList = $activeModal.find('.collection-list');
      _this.getCollections();

      let delaySearch;
      let delayAjaxSearch;
      $activeModal
        .find('#search-collection')
        .off('keyup paste')
        .on('keyup paste', function () {
          clearTimeout(delaySearch);
          clearTimeout(delayAjaxSearch);

          let count = 0;
          const input = jQuery(this).val().trim().toLowerCase();
          $activeModal.find('.search_notfound').removeClass('active');

          delaySearch = setTimeout(function () {
            if (input !== '') {
              $collectionsList.find('ul li').hide();
              const $collection = $collectionsList.find('ul li');
              for (let i = 0; i < $collection.length; i++) {
                const title = $($collection[i]).find('span').text().toLowerCase();
                if (title.indexOf(input) >= 0) {
                  $($collection[i]).show();
                  count++;
                }
              }
            } else {
              $collectionsList.find('ul li').show();
            }
          }, 10);

          delayAjaxSearch = setTimeout(function () {
            if (input !== '') {
              _this.searchCollection(input, count);
            }
          }, 500);
        });

      return false;
    };

    this.renderNotice = function () {
      const html = `<div class="gf-collection-selector-notice"><div class="icon icon-warn-circle"></div><div class="gf-collection-selector-notice--desc">"Unavailable" collections can't be viewed on live page. You can change collections status in Shopify.</div></div>`;
      const notice = $activeModal.find('.gfCS_body .gf-collection-selector-notice');
      if (!notice || !notice.length) {
        $activeModal.find('.gfCS_body').prepend(html);
      }
    };

    this.setClassScroll = function () {
      const $collectionListItems = $activeModal.find('.collection-list ul');
      $collectionListItems.removeClass('has-scroll');
      if ($collectionListItems.height() > 443) {
        $collectionListItems.addClass('has-scroll');
      }
    };

    this.getCollections = function () {
      $collectionsList = $activeModal.find('.collection-list');
      const shop = $gfFrame.data('gfframe').getShopDomain();
      const data = {
        shop: shop,
        limit: 50,
      };
      const $gfModalReload = $activeModal.find('.gf_modal-header .gf_modal-right .gf_modal-reload');
      $gfModalReload.attr('disabled', true);
      $gfModalReload.html($elIconLoading);
      _this.hideGfTooltipNew();
      GET(api.getCollections().url, data)
        .then((res) => {
          const jsonData = res.data;
          if (!jQuery.isEmptyObject(jsonData)) {
            _collectionsData = jsonData['collections'];
            const _collections = jsonData['collections'];

            // COLLECTION 2019
            for (let i = 0; i < _collections.length; i++) {
              HELPER.updateCollectionInList(_collections[i]);
            }

            let html = '';
            html +=
              '<li data-cId="auto" data-cHandle="latest-products" data-cTitle="All Collections"><div class="gfCS_thumbnail"><div class="gfCS_icon_auto"></div></div><span class="gfCS_title">Automatic (Latest Collection)</span></li>';

            html = _this.renderCollections(_collections, html);
            html = '<ul>' + html + '</ul>';

            // $collectionsList.html(html).addClass('optiscroll').optiscroll();
            $collectionsList.html(html).addClass('optiscroll');
            _this.setClassScroll();
            $activeModal.data('gfmodalnew').offLoading();
            $gfModalReload.removeAttr('disabled');
            $gfModalReload.html($elIconRefresh);
            _this.bindCollectionEvents();
          }
        })
        .catch((err) => {
          HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
        });
    };

    this.renderCollections = function (collections, html) {
      for (let i = 0; i < collections.length; i++) {
        const published_at = (collections[i] && collections[i].published_at) || '';
        html +=
          '<li data-cId="' +
          collections[i].id +
          '" data-cPublishedAt="' +
          published_at +
          '" data-cHandle="' +
          collections[i].handle +
          '" data-cTitle="' +
          collections[i].title +
          '">';
        if (collections[i].image && collections[i].image.src) {
          // Src image small
          const smallSrc = HELPER.getImageSmall(collections[i].image.src, {
            width: 40,
            height: 40,
          });
          html += '<div class="gfCS_thumbnail">';
          html += '<img src="' + smallSrc + '" />';
          html += '</div>';
        } else {
          html += '<div class="gfCS_thumbnail">';
          html += '<div class="gfCS_icon_thumbnail"></div>';
          html += '</div>';
        }

        html += '<span class="gfCS_title">' + collections[i].title + '</span>';
        const publishedAt = this.renderStatusCollection(published_at);
        if (publishedAt) {
          html += "<div class='gfCS_status'><span class='tag'>" + publishedAt.title + '</span></div>';
        }

        html += '</li>';
      }
      return html;
    };

    this.renderStatusCollection = function (publishedAt) {
      if (!publishedAt) {
        return {
          title: 'Unavailable',
        };
      }
      return '';
    };

    this.bindCollectionEvents = function () {
      $collectionsList
        .find('ul li')
        .off('click')
        .on('click', function () {
          const cTitle = jQuery(this).attr('data-cTitle');
          const cId = jQuery(this).attr('data-cId');
          const cHandle = jQuery(this).attr('data-cHandle');
          const collectionPublishedAt = jQuery(this).attr('data-cPublishedAt');

          const $cHandle = $element.parents('.columns').siblings().find('#cHandle');
          const $cId = $element.parents('.columns').siblings().find('#cId');
          _cId = cId;

          const valueCId = typeof $cId.attr('value') != undefined ? $cId.attr('value') : $cId.attr('default_value');
          const valueCHandle =
            typeof $cHandle.attr('value') != undefined ? $cHandle.attr('value') : $cHandle.attr('default_value');

          if (valueCId != cId || valueCHandle != cHandle) {
            // set collection new
            const moduleId = $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
            _this.applyStatusSidebarSettings(collectionPublishedAt);
            _this.addClassInputByStatus(collectionPublishedAt);

            setTimeout(function () {
              $element
                .attr('data-value', cTitle)
                .attr('value', cTitle)
                .val(cTitle)
                .trigger('value-change')
                .trigger('input-change');

              $cHandle.attr('default-value', cHandle).attr('value', cHandle).val(cHandle);
              $cId.attr('default-value', cId).attr('value', cId).val(cId).trigger('input-change');

              $cId.trigger('history-change');
            }, 100);

            let $settings = '';
            let fields = [];

            try {
              const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
              $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
              fields = jQuery.parseJSON($settings);
            } catch (err) {
              console.log(err.message);
            }
            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name == 'collection') {
                fields[i].default_value = cTitle;
              }
              if (fields[i].name == 'cId') {
                fields[i].default_value = cId;
              }
              if (fields[i].name == 'cHandle') {
                fields[i].default_value = cHandle;
              }
            }
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });

            _this.settings.detectChange();

            $activeModal.remove();
          } else {
            $activeModal.remove();
          }
          return false;
        });
    };

    this.searchCollection = function (s, count) {
      const shop = $gfFrame.data('gfframe').getShopDomain();

      const data = {
        shop: shop,
        s: s,
        limit: 249,
      };
      GET(api.searchCollections().url, data)
        .then((res) => {
          const jsonData = res.data;
          if (!jQuery.isEmptyObject(jsonData)) {
            const _collections = jsonData['collections'];

            // Check search !== search off
            for (let k = 0; k < _collectionsData.length; k++) {
              for (let j = 0; j < _collections.length; j++) {
                if (_collections[j].id == _collectionsData[k].id) {
                  _collections.splice(j, 1);
                }
              }
            }
            // push store data
            for (let i = 0; i < _collections.length; i++) {
              _collectionsData.push(_collections[i]);
            }
            if (_collections.length > 0) {
              let html = '';
              html = _this.renderCollections(_collections, html);
              $collectionsList.find('ul').append(html);
              _this.setClassScroll();
              _this.bindCollectionEvents();
            } else {
              if (count == 0) {
                // not found
                $activeModal.find('.search_notfound').addClass('active');
              }
            }
          }
        })
        .catch((err) => {
          HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
        });
    };
    this.init();
  };

  jQuery.fn.gfCollectionSelector = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfcollectionselector')) {
        const plugin = new jQuery.gfCollectionSelector(this, options);
        jQuery(this).data('gfcollectionselector', plugin);
      }
    });
  };
})(jQuery);
